<template>
  <div>
    <div class="app-main-inner-row" style="padding-top: 10px;">
      <div class="filters">
        <el-form
          :inline="true"
          label-width="50px"
          label-position="left"
          @submit.native.prevent="filter.pageNum=1;toQuery()"
        >
          <el-form-item :label="$t('common.btn.query')">
            <el-input
              v-model="filter.likeName"
              no="queryInput"
              :placeholder="$t('common.tips.fuzzySearch')"
              style="width:310px"
            />
          </el-form-item>
        </el-form>
      </div>
      <div class="triggers">
        <el-button no="query" type="primary" @click="filter.pageNum=1;toQuery()">{{ $t('common.btn.query') }}</el-button>
        <el-button no="new" type="primary" @click="showEditDialog(true)">{{ $t('common.btn.new') }}</el-button>
        <el-button no="edit" type="primary" @click="showEditDialog(false)">{{ $t('common.btn.edit') }}</el-button>
        <el-button no="delete" size="mini" type="danger" @click="remove">{{ $t('common.btn.delete') }}</el-button>
        <el-button no="exportExcel" type="primary" @click="exportExcel">{{ $t('common.btn.exportExcel') }}</el-button>
      </div>
    </div>
    <div class="app-main-inner-row row-grid">
      <cargo-ag-grid
        no="grid"
        config-module="101320"
        :grid-params.sync="girdParams"
        :grid-options="gridOptions"
        :column-defs="columnDefs"
        :row-data="rowData"
      />
    </div>
    <div class="app-main-inner-row row-pagination">
      <cargo-pagination
        v-show="total>0"
        no="pagination"
        :total="total"
        :page.sync="filter.pageNum"
        :limit.sync="filter.pageSize"
        @pagination="toQuery"
      />
    </div>
    <!-- 编辑弹窗 -->
    <el-dialog
      v-el-drag-dialog
      :visible.sync="editDialog.visible"
      :title="editDialog.title"
      width="400px"
      :close-on-click-modal="false"
    >
      <div class="app-main-inner-row" style="padding-bottom: 10px;">
        <el-form label-width="100px" label-position="left">
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.serialNumber')">
            <el-input-number
              v-model="editDialog.form.serialNumber"
              no="serialNumber"
              :controls="false"
              :min="0"
              style="width: 162px"
              @blur="serialNumberBlur"
            />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.code')">
            <el-input v-model="editDialog.form.code" no="code" />
          </el-form-item>
          <span v-if="!editDialog.form.uuid">{{ $t('baseInfo.basicData.cutomJobType.codeTips1') }}</span>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.name')">
            <el-input v-model="editDialog.form.name" no="name" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.localName')">
            <el-input v-model="editDialog.form.localName" no="localName" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.englishName')">
            <el-input v-model="editDialog.form.englishName" no="englishName" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.interchangeCode')">
            <el-input v-model="editDialog.form.interchangeCode" no="interchangeCode" />
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.type')">
            <el-select v-model="editDialog.form.lob" no="lob">
              <el-option
                v-for="item in types"
                :key="item.value"
                :label="item.label"
                :value="item.value"
              />
            </el-select>
          </el-form-item>
          <el-form-item :label="$t('baseInfo.basicData.cutomJobType.remarks')">
            <el-input v-model="editDialog.form.remarks" no="remarks" type="textarea" :rows="3" />
          </el-form-item>
        </el-form>
      </div>
      <span slot="footer">
        <el-button no="save" type="primary" @click="save">{{ $t('common.btn.save') }}</el-button>
        <el-button no="cancel" @click="editDialog.visible=false">{{ $t('common.btn.cancel') }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { getTransmitFileTypeList, saveTransmitFileType, delTransmitFileType } from '@/api/basicData/transmitFileType'
import ColumnUtils from '@/utils/ColumnUtils'
import { getLoading } from '@/utils/utilBaseElement'

export default {
  name: 'TransmitFileType',
  data() {
    return {
      filter: {
        likeName: '',
        pageNum: 1,
        pageSize: 50
      },
      total: 0,
      girdParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        defaultColDef: {
          menuTabs: [], // 去掉每列的菜单
          filter: true
        }
      },
      types: [],
      columnDefs: [
        {
          headerName: '',
          checkboxSelection: true,
          width: 55,
          sortable: false,
          suppressMenu: true,
          suppressSizeToFit: true,
          resizable: false,
          headerCheckboxSelection: true
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.serialNumber'),
          field: 'serialNumber',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.code'),
          field: 'code',
          width: 100
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.name'),
          field: 'name',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.localName'),
          field: 'localName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.englishName'),
          field: 'englishName',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.interchangeCode'),
          field: 'interchangeCode',
          width: 200
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.type'),
          field: 'lob',
          width: 100,
          cellRenderer: params => {
            return ColumnUtils.jobBussStateLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('baseInfo.basicData.cutomJobType.remarks'),
          field: 'remarks',
          width: 200
        }
      ],
      rowData: null,
      editDialog: {
        visible: false,
        title: '',
        form: {
          uuid: '',
          serialNumber: 0,
          code: '',
          name: '',
          localName: '',
          englishName: '',
          lob: '',
          remarks: ''
        }
      }
    }
  },
  computed: {
    gridApi() {
      return this.girdParams.api
    }
  },
  created() {
    this.types.push({ label: this.$t('constant.systemConstants.SE'), value: 'SE' })
    this.types.push({ label: this.$t('constant.systemConstants.SI'), value: 'SI' })
    this.types.push({ label: this.$t('constant.systemConstants.AE'), value: 'AE' })
    this.types.push({ label: this.$t('constant.systemConstants.AI'), value: 'AI' })
    this.types.push({ label: this.$t('constant.systemConstants.RE'), value: 'RE' })
    this.types.push({ label: this.$t('constant.systemConstants.IE'), value: 'IE' })
    this.typeMap = new Map()
    for (const item of this.types) {
      this.typeMap.set(item.value, item.label)
    }
  },
  methods: {
    onShow() {
      if (this.rowData === null) {
        this.rowData = []
        this.toQuery()
      }
    },
    toQuery() {
      const self = this
      const loading = getLoading()
      getTransmitFileTypeList(self.filter).then(res => {
        if (self.gridApi) {
          self.gridApi.setRowData(res.data.list)
        } else {
          self.rowData = res.data.list
        }
        self.filter.pageNum = res.data.pageNum
        self.filter.pageSize = res.data.pageSize
        self.total = Number(res.data.total)
      }).finally(() => loading.close())
    },
    showEditDialog(isNew) {
      if (isNew) {
        this.editDialog.form = {
          uuid: '',
          serialNumber: 0,
          code: '',
          name: '',
          localName: '',
          englishName: '',
          lob: '',
          remarks: ''
        }
        this.editDialog.title = this.$t('CargoMsg.Cargo_NewTo') + this.$t('CargoMsg.Cargo_CirculationDocumentType')
      } else {
        const rows = this.gridApi.getSelectedRows()
        if (rows.length === 0) {
          this.$message.warning(this.$t('common.tips.hasOneAtleast'))
          return
        }
        this.editDialog.form = { ...rows[0] }
        this.editDialog.title = this.$t('CargoMsg.Cargo_EditTo') + this.$t('CargoMsg.Cargo_CirculationDocumentType')
      }
      this.editDialog.visible = true
    },
    serialNumberBlur() {
      const form = this.editDialog.form
      const val = Number(form.serialNumber)
      if (isNaN(val)) {
        form.serialNumber = ''
        return
      }
      form.serialNumber = val.toFixed(0)
    },
    save() {
      const self = this
      const form = self.editDialog.form
      if (!form.code) {
        this.$message.warning(this.$t('CargoMsg.Cargo_CodeCanTBeEmpty'))
        return
      }
      if (!form.name) {
        this.$message.warning(this.$t('CargoMsg.Cargo_NameCanTBeEmpty'))
        return
      }
      if (!form.englishName) {
        this.$message.warning(this.$t('CargoMsg.Cargo_EnglishNameCheck'))
        return
      }
      if (!form.interchangeCode) {
        this.$message.warning(this.$t('CargoMsg.Cargo_ExchangeCodeCanTBeEmpty'))
        return
      }
      if (!form.lob) {
        this.$message.warning(this.$t('CargoMsg.Cargo_BusinessTypeCanTBeEmpty'))
        return
      }
      saveTransmitFileType(form).then(res => {
        if (!form.uuid) {
          self.filter.pageNum = 1
        }
        self.toQuery()
        self.editDialog.visible = false
        self.$message.success(self.$t('common.tips.saveSuccess'))
      }).catch(() => {
        self.editDialog.visible = false
      })
    },
    remove() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        self.$message.warning(self.$t('common.tips.hasOneAtleast'))
        return
      }
      self.$confirm(self.$t('common.tips.confirmDelete'), self.$t('common.tips.prompt'), {
        confirmButtonText: self.$t('common.btn.ok'),
        cancelButtonText: self.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        self.syncRemove(rows, 0)
      }).catch(() => { })
    },
    syncRemove(rows, index) {
      const self = this
      if (index < rows.length) {
        delTransmitFileType(rows[index].uuid).then(res => {
          self.syncRemove(rows, index + 1)
        }).catch(() => {
          if (index > 0) {
            self.filter.pageNum = 1
            self.toQuery()
          }
        })
      } else {
        self.filter.pageNum = 1
        self.toQuery()
        self.$message.success(self.$t('common.tips.deleteSuccess'))
      }
    },
    exportExcel() {
      const self = this
      const rows = self.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      import('@/vendor/Export2Excel').then(excel => {
        const tHeader = [
          this.$t('baseInfo.basicData.cutomJobType.serialNumber'),
          this.$t('baseInfo.basicData.cutomJobType.code'),
          this.$t('baseInfo.basicData.cutomJobType.name'),
          this.$t('baseInfo.basicData.cutomJobType.localName'),
          this.$t('baseInfo.basicData.cutomJobType.englishName'),
          this.$t('baseInfo.basicData.cutomJobType.interchangeCode'),
          this.$t('baseInfo.basicData.cutomJobType.type'),
          this.$t('baseInfo.basicData.cutomJobType.remarks')
        ]
        const filterVal = ['serialNumber', 'code', 'name', 'localName', 'englishName', 'interchangeCode', 'lobStr', 'remarks']
        rows.forEach(row => { row.lobStr = ColumnUtils.jobBussStateLabelFunc(row.lob) })
        const data = self.formatJson(filterVal, rows)
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: 'TransmitFileType'
        })
      })
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map(v => filterVal.map(j => v[j]))
    }
  }
}
</script>

<style>
</style>
